"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var qrcode_react_1 = require("qrcode.react");
var QRCodeComponent = function (_a) {
    var value = _a.value, _b = _a.size, size = _b === void 0 ? 180 : _b, _c = _a.bgColor, bgColor = _c === void 0 ? '#ffffff' : _c, _d = _a.fgColor, fgColor = _d === void 0 ? '#000000' : _d;
    return (React.createElement(qrcode_react_1.QRCodeSVG, { value: value || ' ', size: size, bgColor: bgColor, fgColor: fgColor }));
};
exports.default = QRCodeComponent;
